<template>
    <v-dialog v-model="dialog" width="700px">
        <v-card>
            <v-card-title>Search for Hosts to pay</v-card-title>
            <v-container fluid>
                <v-text-field v-model=maxAmount prefix="€" label="Maximum amount"></v-text-field> 
                <v-row v-if="hcbo.totaalBedrag > 0">
                    <v-col>
                        Total amount : {{hcbo.totaalBedrag}}
                    </v-col>
                </v-row> 
            </v-container>
            <showProgress ref="showProgress"></showProgress> 
            <v-card-actions>  
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2"  :disabled="searchStarted" small @click="searchHoct">Search</v-btn>
                <v-btn color="primary"  :disabled="searchStarted" small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import showProgress from "@/components/showProgress.vue";
    
    export default {
        components: {
            showProgress,
        },
        data() { 
            return {
                dialog: false,
                searchStarted: false,
                maxAmount: 1000000,
                hcbo: {},
            }
        },
        watch: {
            maxAmount(value) {
                this.$emit("setAmount", value);
            }
        },
        methods: {
            openDialog(maxAmount) {
                this.maxAmount = maxAmount;
                this.dialog = true;
            },
            searchHoct() {
                this.$emit("showSnackbar");
                this.searchStarted = true;
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/task/fin/abn/searchHoctToAddHcbo.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchHoctToAddHcbo"
                    },
                    searchHoctToAddHcbo: {
                        maxAmount: parseFloat(this.maxAmount)
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hcbo = res.data.searchHoctToAddHcbo;
                        this.$refs.showProgress.close();
                        this.$emit("searchBtod");
                        // this.$router.reload('/task/fin/abn/searchBtodNew'); 
                        this.dialog = false;                    }
                });
            }
        }
    }
</script>

